module.exports = __webpack_public_path__ + "static/media/comment.d8798bee.svg";